var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"list-demo"}},[_c('list-basic'),_c('list-header'),_c('list-icon'),_c('list-content'),_c('list-avatar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }